import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import { Grid, CircularProgress, Alert } from "@mui/material";
import OrganisationsTable from "../components/Tables/OrganisationsTable";
import PageTitle from "../components/Layout/PageTitle";
import AddOrganisationButton from "../components/Buttons/AddOrganisationButton";
import { useOrganisations } from "../hooks/useOrganisations";

function Organisations() {
  const { data: organisations, isLoading, error, isError } = useOrganisations();

  if (isLoading) {
    return (
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} textAlign="center">
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (isError) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Alert severity="error">
            Failed to load organisations: {error?.message || "Unknown error"}
          </Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={1}>
      <PageTitle title="Organisations">
        <AddOrganisationButton />
      </PageTitle>
      <Grid item xs={12}>
        <OrganisationsTable organisations={organisations} />
      </Grid>
    </Grid>
  );
}

export default withAuthenticationRequired(Organisations);
